<div class="container-fluid">
  <app-content-tab-list activeTab="3" type="entities" category="Entities"></app-content-tab-list>
  <div class="row section1 mt-4 align-items-center">
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="home-details">
        <h5 class="home-title">Rating Categories <span>
          @if (loading) {
            <img src="assets/images/loading.gif" alt="" width="25px">
          }
        </span></h5>
        <p class="home-subtitle">List of all Rating Categories</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="dashboard-btn dashboard-manage ">
        <app-import-data-modal kind="ratings"></app-import-data-modal>
        <div><a routerLink="/ratings/create-rating-category">
          <button class="btn btn-primary btn-dashboard mt-2"><i
          class="las la-plus"></i>Create New Rating Category
        </button>
      </a></div>
      <div class="filter-row filter-row1">
        <div class="form-label show">Sort by :</div>
        <div class="select-wrapper-sm">
          <select class="form-control border-0 input-sm" [(ngModel)]="type" (ngModelChange)="getAllRatingCategories()">
            <option value=1>Entity Categories</option>
            <option value=2>NFT Categories</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row section1">
  <div class="col-12">
    <div class="table-responsive applicants-details overflow-x-visible">
      <table class="table table-bordered user-table">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Icon</th>
            <th scope="col">Name</th>
            <th scope="col">Category</th>
            <th scope="col">Created At</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        @if (!loading && !!categories?.length) {
          <tbody>
            @for (cat of categories; track cat; let i = $index) {
              <tr class="client">
                <td class="text-nowrap" [attr.title]="(cat.id || '').toUpperCase()"><span>{{(cat.id || '').slice(-6).toUpperCase()}}</span>
                <i (click)="handleCopyToClipboard(cat.id);" class="las la-copy la-lg pointer copy-icon"></i>
              </td>
              <td><img src="{{cat.icon}}" alt="" width="50"></td>
              <td>{{cat.name}}</td>
              <td>{{cat.category && cat.category.length ? cat.category[0].categoryName : ''}}</td>
              <td>{{cat.createdAt | date: 'mediumDate'}}</td>
              <td class="action">
                <div class="dropdown">
                  <button type="button" class="btn header-item waves-effect btn-dropdown" id="page-header-user-dropdown"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <a class="   mr-3 text-primary py-2 text-nowrap">
                      View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                      <a class=" dropdown-item  text-info border-bottom py-2 text-nowrap"
                        [routerLink]="['/ratings/edit-rating-category/', cat.id]">
                        <i class="las la-edit mb-1 la-lg align-middle mr-0"></i> Edit</a>
                        <a class=" dropdown-item  text-danger border-bottom py-2 text-nowrap"
                          (click)="removeRatingCategory(cat.id)">
                          <i class="las la-trash mb-1 la-lg align-middle mr-0"></i> Delete</a>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (loading) {
              <tbody>
                @for (q of loaders; track q; let qi = $index) {
                  <tr class="client">
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'150px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{ width:'50px',height: '50px', borderRadius: '50%', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                    <td>
                      <ngx-skeleton-loader [theme]="{width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
          @if (!loading && !categories?.length) {
            <div class="d-flex align-items-center justify-content-center py-5">
              No categories found
            </div>
          }
        </div>
      </div>
    </div>
  </div>
